import { motion } from "framer-motion";
import { SectionHeading } from "@/components/site/primitives";

const VIDEO_URL =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_sobs-iaue/artifacts/ltd19bm1_lv_0_20260823150034_1.mp4";

export function VideoSection() {
  return (
    <section
      className="relative overflow-hidden py-20 sm:py-28"
      style={{ background: "radial-gradient(120% 100% at 50% 0%, #16347A, #0A1E4E 55%, #071538)" }}
      data-testid="video-section"
    >
      <div className="absolute inset-0 paper-grain opacity-40" />
      <div className="container-x relative">
        <SectionHeading
          overline="Watch"
          title="Hear From Our Seasoned Administrators"
          align="center"
          light
        />
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="relative mx-auto mt-12 max-w-4xl"
        >
          <div className="absolute -inset-3 rounded-sm bg-[#D4AF37]/20 blur-2xl" />
          <div className="relative rounded-sm border-2 border-[#D4AF37]/50 bg-black/40 p-2 shadow-2xl">
            <video
              src={VIDEO_URL}
              className="w-full rounded-sm"
              controls
              autoPlay
              muted
              loop
              playsInline
              preload="metadata"
              data-testid="school-video"
            />
          </div>
        </motion.div>
      </div>
      <div className="mt-12 h-1 w-full" style={{ background: "linear-gradient(90deg,#D4AF37,#F5B301,#D4AF37)" }} />
    </section>
  );
}
